
define('ldsh!modules/expense/item/template', [], function() {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<h1>Expense</h1>\n<dl>\n\n</dl>';

}
return __p
};});

